import { isPlaceholderCharacterName } from '../../js/rankings/components/character-name-utils.js';

const dismissNotificationPanel = () => {
  const panel = document.getElementById('notification-panel');
  if (panel) panel.remove();
};

const applyOpenCharacterParams = (url, characterId, { isPrivate = false, name = '' } = {}) => {
  url.searchParams.set('character', String(characterId));
  url.searchParams.set('action', 'open_character');
  if (isPrivate) url.searchParams.set('is_private', 'true');
  else url.searchParams.delete('is_private');

  const trimmedName = typeof name === 'string' ? name.trim() : '';
  if (trimmedName && !isPlaceholderCharacterName(trimmedName, characterId)) {
    url.searchParams.set('character_name', trimmedName);
  } else {
    url.searchParams.delete('character_name');
  }
  return url;
};

export function navigateToScenario(scenarioId, characterId, scenarioName = '') {
  dismissNotificationPanel();

  const isOnRankingsPage = typeof window !== 'undefined' && window.location.pathname.includes('rankings');
  if (isOnRankingsPage) {
    const url = new URL(window.location.href);
    url.searchParams.set('character', characterId);
    url.searchParams.set('scenario', scenarioId);
    url.searchParams.set('action', 'open_scenario');
    if (scenarioName) url.searchParams.set('scenario_name', scenarioName);
    window.history.replaceState({}, '', url.toString());
    document.dispatchEvent(new CustomEvent('rankingsOpenScenario', {
      detail: { characterId: String(characterId), scenarioId: String(scenarioId) }
    }));
    return;
  }

  const url = new URL('/rankings.html', window.location.origin);
  url.searchParams.set('character', characterId);
  url.searchParams.set('scenario', scenarioId);
  url.searchParams.set('action', 'open_scenario');
  if (scenarioName) url.searchParams.set('scenario_name', scenarioName);
  window.location.href = url.toString();
}

export function navigateToCharacter(characterId, options = {}) {
  dismissNotificationPanel();

  const isPrivate = !!options.isPrivate;
  const name = options.name || '';

  const isOnRankingsPage = typeof window !== 'undefined' && window.location.pathname.includes('rankings');
  if (isOnRankingsPage) {
    const url = applyOpenCharacterParams(new URL(window.location.href), characterId, { isPrivate, name });
    window.history.replaceState({}, '', url.toString());
    document.dispatchEvent(new CustomEvent('rankingsOpenCharacter', {
      detail: {
        characterId: String(characterId),
        isPrivate,
        characterName: name || ''
      }
    }));
    return;
  }

  const url = applyOpenCharacterParams(new URL('/rankings.html', window.location.origin), characterId, { isPrivate, name });
  window.location.href = url.toString();
}

export function navigateToCreateVideo(characterId, outfitId, actionId, intent) {
  dismissNotificationPanel();

  const url = new URL('/create-video.html', window.location.origin);
  url.searchParams.set('mode', 'video-text');
  if (characterId) url.searchParams.set('char', characterId);
  if (outfitId !== undefined && outfitId !== null) url.searchParams.set('outfit', outfitId);
  if (actionId !== undefined && actionId !== null) url.searchParams.set('action', actionId);
  if (intent) url.searchParams.set('intent', intent);
  window.location.href = url.toString();
}

export function navigateToMyGallery() {
  dismissNotificationPanel();
  window.location.href = new URL('/my-gallery.html', window.location.origin).toString();
}
